var _path, _path2, _path3, _path4, _path5, _path6, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 485 485",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.803,356.872c27.516,0,49.901-22.386,49.901-49.902s-22.386-49.902-49.901-49.902s-49.901,22.386-49.901,49.902 S57.287,356.872,84.803,356.872z M84.803,287.069c10.974,0,19.901,8.928,19.901,19.902s-8.928,19.902-19.901,19.902 s-19.901-8.928-19.901-19.902S73.829,287.069,84.803,287.069z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.803,385.041C38.042,385.041,0,423.084,0,469.844v15h169.605v-15C169.605,423.084,131.563,385.041,84.803,385.041z  M32.087,454.844c6.539-22.95,27.697-39.803,52.716-39.803s46.177,16.854,52.716,39.803H32.087z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400.197,356.872c27.516,0,49.901-22.386,49.901-49.902s-22.386-49.902-49.901-49.902s-49.901,22.386-49.901,49.902 S372.682,356.872,400.197,356.872z M400.197,287.069c10.974,0,19.901,8.928,19.901,19.902s-8.928,19.902-19.901,19.902 s-19.901-8.928-19.901-19.902S389.224,287.069,400.197,287.069z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M400.197,385.041c-46.761,0-84.803,38.042-84.803,84.803v15H485v-15C485,423.084,446.958,385.041,400.197,385.041z  M347.481,454.844c6.539-22.95,27.697-39.803,52.716-39.803s46.177,16.854,52.716,39.803H347.481z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.5,99.959c27.516,0,49.901-22.386,49.901-49.902S270.016,0.156,242.5,0.156s-49.901,22.386-49.901,49.902 S214.984,99.959,242.5,99.959z M242.5,30.156c10.974,0,19.901,8.928,19.901,19.902s-8.928,19.902-19.901,19.902 s-19.901-8.928-19.901-19.902S231.526,30.156,242.5,30.156z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327.303,212.931c0-46.761-38.042-84.803-84.803-84.803s-84.803,38.042-84.803,84.803v15h169.605V212.931z  M189.784,197.931c6.539-22.95,27.697-39.803,52.716-39.803s46.177,16.854,52.716,39.803H189.784z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "257.5,330.939 257.5,262.816 227.5,262.816 227.5,330.939 168.504,365 183.504,390.981 242.5,356.919  301.496,390.981 316.496,365  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/Team.4c9ea841.svg";
export { ForwardRef as ReactComponent };